module.exports = __webpack_public_path__ + "img/HSA Web Banner.a16c32f0.png";